import { useEffect, useState } from 'react';
import { Link } from 'react-router-dom';
import { ChatBubbleLeftEllipsisIcon, ChevronRightIcon } from '@heroicons/react/24/outline';
import { listChats, type Chat } from '../api/unimedica';

/** Fruehere Chats zu dieser Akte (#28, Mario 01.11.2026: „Ich moechte einen historischen Eintrag wieder
 *  aufgreifen“). Bisher fand man sie nur links in der Chat-Seitenleiste; der Knopf in der Akte oeffnet immer
 *  einen NEUEN Chat. Jeder Eintrag oeffnet den gespeicherten Chat (/chat?chat=<id>), dort kann man weiterschreiben.
 *  Verglichen wird ueber die Patientennummer vorne (Ordnername der Akte kann sich bei Namenskorrekturen aendern). */
const ID = (s: string | null | undefined) => (s ?? '').split('_')[0];
const datum = (iso: string) => {
  try { return new Date(iso).toLocaleDateString('de-CH', { day: '2-digit', month: '2-digit', year: '2-digit' }); } catch { return ''; }
};

export default function AkteChats({ pid }: { pid: string }) {
  const [chats, setChats] = useState<Chat[] | null>(null);
  const [alle, setAlle] = useState(false);

  useEffect(() => {
    let weg = false;
    listChats()
      .then((cs) => {
        if (weg) return;
        const nr = ID(pid);
        setChats(cs.filter((c) => (c.mode === 'patient' || c.mode === 'patient_md') && nr && ID(c.patient_id) === nr)
          .sort((a, b) => (b.updated_at || '').localeCompare(a.updated_at || '')));
      })
      .catch(() => { if (!weg) setChats([]); });
    return () => { weg = true; };
  }, [pid]);

  if (!chats || chats.length === 0) return null;
  const sichtbar = alle ? chats : chats.slice(0, 5);
  return (
    <div className="card overflow-hidden p-0">
      <div className="flex items-center gap-2 border-b border-gray-200 bg-gray-50 px-4 py-3">
        <ChatBubbleLeftEllipsisIcon className="h-4 w-4 shrink-0 text-primary-500" />
        <span className="text-[15px] font-medium text-ps-dark-900">Frühere Chats zu dieser Akte</span>
        <span className="numerical ml-auto text-xs text-ps-dark-400">{chats.length}</span>
      </div>
      <ul className="divide-y divide-gray-100">
        {sichtbar.map((c) => (
          <li key={c.id}>
            <Link to={`/chat?chat=${encodeURIComponent(c.id)}`} title="Chat öffnen und weiterschreiben"
              className="flex min-h-11 items-center gap-2 px-4 py-2 text-sm text-ps-dark-700 hover:bg-primary-50 hover:text-primary-700">
              <span className="min-w-0 flex-1 truncate">{c.title || 'Chat'}</span>
              {c.shared_with_me_by && <span className="badge-neutral shrink-0 text-[10.5px]">geteilt</span>}
              <span className="numerical shrink-0 text-[11.5px] text-ps-dark-400">{datum(c.updated_at)}</span>
              <ChevronRightIcon className="h-3.5 w-3.5 shrink-0 text-ps-dark-300" />
            </Link>
          </li>
        ))}
      </ul>
      {chats.length > 5 && (
        <button type="button" onClick={() => setAlle((v) => !v)}
          className="w-full border-t border-gray-100 px-4 py-2 text-left text-xs font-medium text-primary-600 hover:bg-gray-50">
          {alle ? 'Weniger anzeigen' : `Alle ${chats.length} anzeigen`}
        </button>
      )}
    </div>
  );
}
